import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import mobileviewiosIcon from "Assets/Svg/appstore.svg";
import mobileviewandridIcon from "Assets/Svg/getitongoogleplay.svg";
import classNames from "classnames";
import { detect } from "detect-browser";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import publicIp from "public-ip";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  LogMeOut,
  SubscriptionLogin,
  updateAuthentication,
} from "../../Actions/AuthenticationAction";
import { instance } from "../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  getFormattedPermissions,
  SetAppMode,
} from "../../Actions/commonAction";
import { ChangeLanguage } from "../../Actions/LanguageAction";
import "../../Assets/Css/index.css";
import ca from "../../Assets/Svg/login-idp/ca.jpg";
import gsuite from "../../Assets/Svg/login-idp/gsuite.png";
import microsoft from "../../Assets/Svg/login-idp/microsoft.jpg";
import okta from "../../Assets/Svg/login-idp/okta.png";
import onelogin from "../../Assets/Svg/login-idp/onelogin.png";
import ping from "../../Assets/Svg/login-idp/ping.png";
import rsasecurid from "../../Assets/Svg/login-idp/rsasecurid.jpg";
import ClientsPage from "../../Component/Clients/index";
import { FEATUREKEYS } from "../../Constants";
import { getOSName } from "../../Handlers/getters";
import { getFormattedLogoLink } from "../../Utils";
import { ValidateAction, ValidateReqField } from "../../Utils/Validation";
import "../SignUp/LeadSignup/LeadSignup.css";
import "./Login.css";

const browser = detect();

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    height: 56,
  },
  leadloginbutton: {
    width: 200,
    height: 56,
  },
  dense: {},
  padding30: {
    padding: 30,
  },
  root: {
    flexGrow: 1,
  },
});

class SubscriptionApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subdomain: window.location.hostname,
      password: "",
      showPassword: false,
      fields: {
        name: "",
        password: "",
      },
      reqFields: {
        name: "",
        password: "",
      },
      errors: {},
      helperText: {},
      identityProvider: [],
      identityp: null,
      identityimage: null,
      datareceived: false,
      version: null,
    };
    this.validateStart = this.validateStart.bind(this);
    this.SubscriptionLogin = this.SubscriptionLogin.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("subscriptionlogin");
  }

  componentDidMount() {
    const { SubscriptionData } = this.props.SubscriptionInfo;
    // initial check if merchant's subscription and trialexpired is expired if not then push them back to login
    if (
      Object.keys(SubscriptionData) &&
      Object.keys(SubscriptionData).length > 0 &&
      (SubscriptionData.statusid === 4 || SubscriptionData.statusid === 7)
    ) {
      this.props.history.push("/trialexpired");
    } else if (
      Object.keys(SubscriptionData) &&
      Object.keys(SubscriptionData).length > 0 &&
      SubscriptionData.statusid === 1
    ) {
      this.props.history.push("/");
    }
    if (document.referrer.includes("request_center")) {
      localStorage.setItem("prevLink", document.referrer);
    } else if (document.referrer.includes("org_not_found")) {
      this.props.enqueueSnackbar("Organisation is not registered for SSO", {
        variant: "error",
      });
    } else if (document.referrer.includes("session-expired")) {
      this.props.enqueueSnackbar("Session expired, Please login again", {
        variant: "error",
      });
    } else if (document.referrer.includes("user_error")) {
      this.props.enqueueSnackbar("Login fail, please try again", {
        variant: "error",
      });
    }
    sessionStorage.setItem("appMode", "");
    if (
      get(this.props, "AuthenticationAction.IsFulfilled", "") &&
      get(this.props, "AuthenticationAction.login.features", "")
    ) {
      // this.props.history.push("/home");
      const prev = window.localStorage.getItem("prevLink");
      // console.log('prev: ', prev);
      // if (prev && prev.includes("request_center")) {
      if (prev) {
        window.open(prev, "_self");
        localStorage.removeItem("prevLink");
        // const prev1 = window.localStorage.getItem("prevLink");
        // console.log('prev1: ', prev1);
      } else {
        window.open("/desk", "_self");
      }
      return;
    }
    this.getIdpProviders();
    // this.setState({
    //   datareceived: true,
    // });
    this.props.SetAppMode("");
    this.getVersion();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.SubscriptionDetails.idptypeid !==
      prevProps.SubscriptionDetails.idptypeid
    ) {
      this.getIdpProviders();
    }
  }

  getIdpProviders() {
    instance
      .get("superuser/getmastercode/IdentityProviderType")
      .then((result) => {
        const id =
          result.data.result.find(
            (x) => x.displayvalue == this.props.SubscriptionDetails.idptypeid,
          ) &&
          result.data.result.find(
            (x) => x.displayvalue == this.props.SubscriptionDetails.idptypeid,
          ).displayvalue;
        this.setState(
          {
            identityp: null,
            datareceived: false,
          },
          () => {
            this.setState({
              identityProvider: result.data.result,
              identityp: result.data.result.find(
                (x) =>
                  x.displayvalue == this.props.SubscriptionDetails.idptypeid,
              ),
              identityimage: id
                ? id == 1
                  ? gsuite
                  : id == 2
                  ? microsoft
                  : id == 3
                  ? rsasecurid
                  : id == 4
                  ? ca
                  : id == 5
                  ? okta
                  : id == 6
                  ? onelogin
                  : ping
                : null,
              datareceived: true,
            });
          },
        );
      })
      .catch((error) => []);
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  SetHelperTextFlag(field, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  async getVersion() {
    const version = await instance.get(`superuser/getallappversion/1/1`);
    this.setState({ version: version.data.result[0].version });
    localStorage.setItem("appversion", this.state.version);
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  passwordKeyPress = ({ key = null }) =>
    key === "Enter" && this.SubscriptionLogin();

  async validateStart({ loginres }) {
    const isAdmin = loginres.masterprofileid >= 9;
    let hasAttendanceAppAccess = isAdmin;
    let hasLeaveAppAccess = isAdmin;
    let hasExpenseAppAccess = isAdmin;
    let hasPerformAppAccess = isAdmin;
    let hasCompensatorAccess = isAdmin;
    const hasDriveAccess = isAdmin;
    const hasLetterAccess = isAdmin;

    if (!isAdmin) {
      try {
        let data = {
          featurekey: "attendanceLogs",
          workflowfortypeid: 2,
        };
        const attendanceapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasAttendanceAppAccess =
        //   isAdmin || get(attendanceapproverreportee, "data.result[0]", "");

        hasAttendanceAppAccess = get(
          attendanceapproverreportee,
          "data.result[0]",
          "",
        );

        data = {
          featurekey: "leaveBalanceAndHistory",
          workflowfortypeid: 3,
        };
        const leaveapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasLeaveAppAccess =
        //   isAdmin || get(leaveapproverreportee, "data.result[0]", "");

        hasLeaveAppAccess = get(leaveapproverreportee, "data.result[0]", "");

        data = {
          featurekey: "employeeExpense",
          workflowfortypeid: 5,
        };
        const expenseapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasExpenseAppAccess =
        //   isAdmin || get(expenseapproverreportee, "data.result[0]", "");

        hasExpenseAppAccess = get(
          expenseapproverreportee,
          "data.result[0]",
          "",
        );
        const checkiscompensator = await instance.get(
          `expense/checkiscompensator`,
        );
        // hasCompensatorAccess =
        //   isAdmin ||
        //   get(checkiscompensator, "data.result[0].iscompensator", "");

        hasCompensatorAccess = get(
          checkiscompensator,
          "data.result[0].iscompensator",
          "",
        );

        data = {
          featurekey: "degree",
          workflowfortypeid: 6,
        };
        const performapproverreportee = await instance.post(
          `attendance/approverreportee`,
          data,
        );
        // hasPerformAppAccess =
        //   isAdmin || get(performapproverreportee, "data.result[0]", "");

        hasPerformAppAccess = get(
          performapproverreportee,
          "data.result[0]",
          "",
        );
      } catch (err) {
        this.props.enqueueSnackbar(
          get(
            err,
            "responses.data.error.message",
            "Please check username and password",
          ),
          { variant: "error" },
        );
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: null,
        });
        return false;
      }
    }

    if (hasCompensatorAccess) {
      get(loginres, "features", []).push({
        hasAppAccess: true,
        permissions: {
          readOnly: false,
          editable: true,
        },
        featureid: 314,
      });
    }

    loginres = {
      ...loginres,
      features: get(loginres, "features", []).map((feature) => {
        const res = feature;
        if (feature.featureid == FEATUREKEYS.attendance) {
          res.hasAppAccess = hasAttendanceAppAccess;
        } else if (feature.featureid == FEATUREKEYS.leave) {
          res.hasAppAccess = hasLeaveAppAccess;
        } else if (feature.featureid == FEATUREKEYS.employeeExpense) {
          res.hasAppAccess = hasExpenseAppAccess;
        } else if (feature.featureid == FEATUREKEYS.adminDashboard) {
          res.hasAppAccess = hasCompensatorAccess;
        } else if (feature.featureid == FEATUREKEYS.companyDrive) {
          res.hasAppAccess = hasDriveAccess;
        } else if (feature.featureid == FEATUREKEYS.letters) {
          res.hasAppAccess = hasLetterAccess;
        } else if (feature.featureid == FEATUREKEYS.degree) {
          res.hasAppAccess = hasPerformAppAccess;
        }
        return res;
      }),
    };

    this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
      IsFulfilled: true,
      data: loginres,
    });

    window.localStorage.setItem(
      "loggedin",
      get(loginres, "data.result[0].userid", ""),
    );
    setTimeout(() => {
      window.location.reload(true);
    }, 200);
  }

  async SubscriptionLogin() {
    const { fields } = this.state;
    const username =
      typeof fields.name === "string" ? fields.name.trim() : fields.name;
    const data = {
      username,
      password: this.state.fields.password,
      subscriptionid: this.props.SubscriptionDetails.subscriptionid,
      browserdetail: browser.name,
      logintype: 1,
      ipaddress: await publicIp.v4(),
      systemdetail: getOSName(),
      devicetokenid: get(this.props, "FCMReducer.devicetokenid", ""),
    };
    if (!data.username || !data.password) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      try {
        const loginresult = await instance.post(
          "subscription/passwordlogin",
          data,
        );
        const plans = await instance.post(`superuser/getcompanyplanconfig`, {
          accountid:
            loginresult.data.result[0] && loginresult.data.result[0].accountid,
          subscriptionid:
            loginresult.data.result[0] &&
            loginresult.data.result[0].subscriptionid,
        });
        const objsuportplan = plans.data.result[0]
          ? plans.data.result.find((x) => x.typeid == 1)
          : null;
        const objpriceplan = plans.data.result[0]
          ? plans.data.result.find((x) => x.typeid == 2)
          : null;
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: {
            ...loginresult.data.result[0],
            objsuportplan,
            objpriceplan,
          },
        });
        const permissionsresult = await instance.get(
          "subscription/getuserpermssion",
        );
        const login = { ...loginresult.data.result[0] };
        login.features = getFormattedPermissions(permissionsresult.data.result);
        const migrationlist = await instance.get(
          "superuser/getconfigmigrationinit",
        );
        login.migration = migrationlist.data.result;
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: login,
        });
        setTimeout(() => {
          this.validateStart({ loginres: login });
        }, 200);
      } catch (e) {
        this.props.enqueueSnackbar(
          get(
            e,
            "response.data.error.message",
            "Please check username and password",
          ),
          { variant: "error" },
        );
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: null,
        });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const language = this.props.Language.subscriptionlogin;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="loginbg subscriptionlogin-page width100">
          {this.state.datareceived &&
            (this.props.SubscriptionDetails.isssoenable
              ? this.props.SubscriptionDetails.idptypeid
              : true) && (
              <div className={classes.root}>
                <Grid container>
                  <Grid item xs={12} md={4} sm={12} style={{ height: "100vh" }}>
                    <div
                      style={{
                        height: "96vh",
                        display: "table",
                        width: "75%",
                        margin: "0 auto",
                      }}
                    >
                      <form
                        className="lead-signup-form1 roleselect"
                        onSubmit={this.SubscriptionLogin}
                      >
                        <div>
                          <div align="center" className="margin-top-20">
                            <img
                              src={getFormattedLogoLink(
                                this.props.SubscriptionDetails.logo,
                              )}
                              style={{ maxHeight: 60, maxWidth: 200 }}
                              alt="logo"
                            />
                          </div>
                          <div
                            className="large-text-dark t-bold margin-top-20 text-center"
                            style={{ margin: "0 auto" }}
                          >
                            {`${this.props.SubscriptionDetails.subscriptionname}’s`}
                          </div>
                          <div
                            className="large-text-dark t-bold text-center"
                            style={{ margin: "0 auto 32px auto" }}
                          >
                            all-in-one HR platform!
                          </div>
                          {this.props.SubscriptionDetails.isssoenable && (
                            <div
                              style={{
                                marginBottom: 24,
                                paddingBottom: 24,
                                borderBottom: "1px dashed #dbd3d3",
                              }}
                            >
                              <div
                                className="margin-top-20 t-14"
                                style={{ margin: "0 auto" }}
                              >
                                SSO Login with{" "}
                                {this.state.identityp &&
                                  this.state.identityp.displayname}
                              </div>
                              <div className="margin-top-16">
                                {this.state.identityimage &&
                                  this.state.identityp && (
                                    <div
                                      className="text-align-center"
                                      onClick={() =>
                                        window.open(
                                          this.props.SubscriptionDetails
                                            .sso_url,
                                          "_self",
                                        )
                                      }
                                      style={{
                                        border: "1px solid #057cff",
                                        borderRadius: 4,
                                        cursor: "pointer",
                                        height: 60,
                                        margin: "0 auto",
                                        boxShadow:
                                          "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
                                      }}
                                    >
                                      <img
                                        src={this.state.identityimage}
                                        style={{
                                          height: 50,
                                          width: 80,
                                          objectFit: "scale-down",
                                        }}
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                          {/* {this.props.SubscriptionDetails
                          .isusernameloginenable && (
                          <div
                            className="t-14 margin-bottom-8"
                            style={{ marginTop: 32 }}
                          >
                            Login with Email/ Emp ID or Phone Number
                          </div>
                        )} */}
                          {this.props.SubscriptionDetails
                            .isusernameloginenable && (
                            <div className="margin-bottom-20">
                              <p className="extra-small-dark-disabled margin-bottom-4">
                                <span>
                                  Email Id / Mobile Number / Employee Code
                                </span>
                              </p>
                              <TextField
                                id="email"
                                // label={<FormattedMessage id="Lbworke-mail" defaultMessage="work e-mail" />}
                                type="text"
                                className={classNames(
                                  classes.dense,
                                  "width100",
                                )}
                                margin="dense"
                                variant="outlined"
                                // placeholder="work e-mail"
                                onFocus={this.SetHelperTextFlag.bind(
                                  this,
                                  "name",
                                )}
                                onChange={this.OnFieldChange.bind(
                                  this,
                                  "name",
                                  "name",
                                )}
                                onBlur={this.ValidateField.bind(
                                  this,
                                  "name",
                                  "name",
                                )}
                                error={!!this.state.errors.name}
                                inputProps={{ maxLength: 128 }}
                              />

                              {this.state.helperText.name ? (
                                <span className="caption-helptest">
                                  <FormattedMessage
                                    id="HtSubscriptionUsername"
                                    defaultMessage="Your work e-mail / employeeID / phonenumber"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                          {this.props.SubscriptionDetails
                            .isusernameloginenable && (
                            <div className="margin-bottom-20">
                              <p className="extra-small-dark-disabled margin-bottom-4">
                                <span>Password</span>
                              </p>
                              <TextField
                                id="password"
                                className={classNames(
                                  classes.dense,
                                  "width100",
                                )}
                                margin="dense"
                                variant="outlined"
                                type={
                                  this.state.showPassword ? "text" : "password"
                                }
                                onFocus={this.SetHelperTextFlag.bind(
                                  this,
                                  "password",
                                )}
                                onChange={this.OnFieldChange.bind(
                                  this,
                                  "password",
                                  "password",
                                )}
                                onBlur={this.ValidateField.bind(
                                  this,
                                  "password",
                                  "password",
                                )}
                                error={
                                  this.state.errors.password &&
                                  this.state.fields.password.length < 8
                                }
                                onKeyPress={this.passwordKeyPress.bind(this)}
                                inputProps={{ maxLength: 256 }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        className="ShowPassword"
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClickShowPassword}
                                      >
                                        {this.state.showPassword ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              {!!this.state.errors.password &&
                              !this.state.helperText.password ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="Erpassword"
                                    defaultMessage="Minimum 8 characters, please 🙏"
                                  />
                                </span>
                              ) : (
                                ""
                              )}

                              {this.state.helperText.password ? (
                                <span className="caption-helptest">
                                  <FormattedMessage
                                    id="Htpassword"
                                    defaultMessage=" The password you used during signup goes here 🔑"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                          <div className="inline-display width100 position-rel margin-top-16">
                            {this.props.SubscriptionDetails
                              .isusernameloginenable && (
                              <Button
                                variant="contained"
                                color="primary"
                                className="btn btn-primary-md-blue width100 BtLogin"
                                onClick={this.SubscriptionLogin.bind(this)}
                              >
                                <FormattedMessage
                                  id="BtLogin"
                                  defaultMessage="Login"
                                />
                              </Button>
                            )}
                            <div
                              className="padding-top-16 t-14 text-center margin-bottom-16"
                              color="primary"
                            >
                              <FormattedMessage
                                id="LkForgotpassword?"
                                defaultMessage="Forgot password?"
                              />
                              <Link to="/forgotpassword">
                                <span className="small-blue">
                                  {" "}
                                  &nbsp; Click here
                                </span>
                              </Link>
                            </div>
                          </div>
                          <p className="input-label text-center margin-top-8">
                            Version {this.state.version}
                          </p>
                          <div className="margin-top-24 text-center">
                            <div style={{ background: "#f7f8f8", padding: 16 }}>
                              <p className="small-dark t-bold margin-bottom-16">
                                Get the app.
                              </p>
                              <div
                                className="display-flex"
                                style={{
                                  justifyContent: "center",
                                }}
                              >
                                <a href="https://play.google.com/store/apps/details?id=io.hrms.sumhr">
                                  <img
                                    src={mobileviewandridIcon}
                                    alt="android-icon"
                                    // height="40"
                                    className="margin-right-24"
                                  ></img>
                                </a>

                                <a href="https://apps.apple.com/us/app/sumhr-all-in-one-hr-platform/id1500895469">
                                  <img
                                    src={mobileviewiosIcon}
                                    alt="ios-icon"
                                    // height="40"
                                  ></img>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </Grid>
                  <ClientsPage
                    hrisLogin
                    clientData={this.props.SubscriptionDetails}
                    login={true}
                  />
                </Grid>
              </div>
            )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionDetails: state.SubscriptionInfo.SubscriptionData,
  Language: state.LanguageAction.Language,
  FCMReducer: state.FCMReducer,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SubscriptionLogin: (data) => SubscriptionLogin(data),
      updateAuthentication,
      ChangeLanguage: (data) => ChangeLanguage(data),
      LogMeOut,
      SetAppMode,
      CommonReducerAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(SubscriptionApp)));
